/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useState, useEffect} from 'react';
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material/styles';
import MUIRichTextEditor from 'mui-rte';
// style
import {
  StyledRichTextEditorWrapper,
  StyledRichTextEditor,
  StyledErrorText,
} from './RichTextEditor.style';

interface RichTextEditorProps {
  label?: string;
  defaultValue?: any;
  error?: boolean;
  readOnly?: boolean;
  key?: string | number;
  helperText?: React.ReactNode;
  onSave?: (data: string) => void;
  onChange?: (state: any) => void;
  onFocus?: () => void;
  onBlur?: () => void;
}

function RichTextEditor({
  label,
  defaultValue,
  error,
  readOnly,
  key,
  helperText,
  onSave,
  onChange,
  onFocus,
  onBlur,
  ...other
}: RichTextEditorProps) {
  const [value, setValue] = useState('');

  const defaultTheme = createTheme();

  Object.assign(defaultTheme, {
    overrides: {
      MUIRichTextEditor: {
        root: {
          paddingLeft: '12px',
        },
        placeHolder: {
          position: 'unset',
          opacity: 0.5,
        },
      },
    },
  });

  useEffect(() => {
    // this effect to force reload this component when defaultValue is changing
    setValue(defaultValue);
  }, [defaultValue]);
  return (
    <>
      <StyledRichTextEditorWrapper>
        <StyledRichTextEditor error={error}>
          <MuiThemeProvider theme={defaultTheme}>
            <MUIRichTextEditor
              label={label}
              key={key}
              defaultValue={value}
              readOnly={readOnly}
              onChange={onChange}
              onBlur={onBlur}
              onFocus={onFocus}
              onSave={onSave}
              {...other}
            />
          </MuiThemeProvider>
        </StyledRichTextEditor>
        {error && <StyledErrorText>{helperText}</StyledErrorText>}
      </StyledRichTextEditorWrapper>
    </>
  );
}
export default RichTextEditor;
